import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$logoPartOne = this.$('logo-part-1');
        this.$logoPartTwo = this.$('logo-part-2');
        this.$mask = this.$('mask');
        this.$visual = this.$('visual')[0];
        this.$videos = this.$('video');
        this.$tagline = this.$('tagline')[0];

        this.compute();

        this.initTimelines();

        this.videosLoaded = 0;
        this.syncVideos();

        this.resizeBind = this.checkResize.bind(this);
        window.addEventListener('resize', this.resizeBind);
    }

    initTimelines() {
        if(this.mainTimeline && this.mainTimeline.kill) {
            gsap.set([this.$mask, this.$visual, this.$logoPartOne, this.$logoPartTwo], { clearProps: 'all' })
            this.mainTimeline.kill()
            this.mainTimeline = null;
            delete this.mainTimeline
        }

        // Main Timeline
        this.mainTimeline = gsap.timeline();
        this.mainTimeline.to(this.$mask, {
            duration: 0.5,
            y: '-100%'
        });
        this.mainTimeline.to(this.$visual, {
            duration: 0.8,
            scale: 0.3*this.visualScaleTarget*1.025
        });
        this.mainTimeline.to(this.$logoPartOne, {
            duration: 0.8,
            delay: -1,
            x: '-150%'
        });
        this.mainTimeline.to(this.$logoPartTwo, {
            duration: 0.8,
            x: '150%'
        }, '<');
        this.mainTimeline.pause();
    }

    syncVideos() {
        this.$videos.forEach(video => {
            video.addEventListener('canplay', () => {
                this.videosLoaded++;
                // videos are all loaded
                if (this.videosLoaded === this.$videos.length) {
                    this.videosLoadedCallback();
                }
            })
        });
    }

    videosLoadedCallback() {
        // console.log(this.$videos)

        this.$videos.forEach(video => {
            const src = video.src;
            video.src = '';
            document.body.offsetTop; // trigger layout
            requestAnimationFrame(() => {
                video.src = src;

                video.play();
                video.currentTime = 0;

                this.$videos[1].currentTime = this.$videos[0].currentTime;
            })
        });

    }

    setProgress(progress) {

        this.mainTimeline.progress(progress * 1.5);
    }

    /**
     * Manage the progress and other anim variables when user scrolls
     *
     * @param {scroll obj} (see Scroll.js)
     */
    onScroll(param) {
        if (window.isMobile) return

        let limit = param[0].section.limit.y - (window.innerHeight * 1.5)
        let scroll = param[1].scroll.y

        let progress = Math.min((scroll / limit).toFixed(3), 1)

        if (progress >= 1)
            progress = 1
        else if (progress <= 0)
            progress = 0

        this.setProgress(progress);
    }

    compute() {
        this.visualBCR = this.$visual.getBoundingClientRect();

        const visualRatio = this.visualBCR.width / this.visualBCR.height;
        const viewportRatio = window.innerWidth / window.innerHeight;

        if(viewportRatio < visualRatio) { // Scale to match height
            this.visualScaleTarget = window.innerHeight / this.visualBCR.height;
        } else { // Scale to match width
            this.visualScaleTarget = window.innerWidth / this.visualBCR.width;
        }
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.compute()
                this.initTimelines();
                this.resizeTick = false
            })
        }
    }

    updateTaglineColor(e) {

        if (e.way === 'enter' && html.getAttribute('data-direction') === 'down') {
            this.$tagline.classList.add('is-visible');
        } else {
            this.$tagline.classList.remove('is-visible');
        }
    }

    destroy() {
        super.destroy();
        window.removeEventListener('resize', this.resizeBind);
    }
}
